export default __webpack_public_path__ + "static/media/5.6005d425.jpg";